// extracted by mini-css-extract-plugin
export default {"contentList":"allCardContainer_contentList__3gorO"};